import { useState, useEffect } from "react";

const getWindowSize = () => ({
  width: typeof window === "object" ? window.innerWidth : undefined,
  height: typeof window === "object" ? window.innerHeight : undefined,
});

export function useWindowSize() {
  const isClient = typeof window === "object";

  const [windowSize, setWindowSize] = useState(getWindowSize);

  useEffect(() => {
    if (!isClient) {
      return;
    }

    function handleResize() {
      setWindowSize(getWindowSize());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [isClient]);

  return windowSize;
}
